import { render, staticRenderFns } from "./InputContainer.vue?vue&type=template&id=72450287&scoped=true&"
import script from "./InputContainer.vue?vue&type=script&lang=js&"
export * from "./InputContainer.vue?vue&type=script&lang=js&"
import style0 from "./InputContainer.vue?vue&type=style&index=0&id=72450287&scoped=true&lang=css&"
import style1 from "./InputContainer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72450287",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/q7gCdwre/0/h5group/renpho-lex/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72450287')) {
      api.createRecord('72450287', component.options)
    } else {
      api.reload('72450287', component.options)
    }
    module.hot.accept("./InputContainer.vue?vue&type=template&id=72450287&scoped=true&", function () {
      api.rerender('72450287', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InputContainer.vue"
export default component.exports